"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarException = void 0;
class StarException extends Error {
    constructor() {
        super("Error favourting message!");
        this.name = "StarException";
    }
}
exports.StarException = StarException;
